export default {
  basic: 'filled-in checkbox-orange',
  classic: 'filled-in checkbox-orange',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/checkbox.js